import { EquipmentStatusCategoryOptions } from '@models/EquipmentStatus.model';
import styled from 'styled-components';

interface ICustomOption {
  fontColor?: string;
}

export const CustomOption = styled.div<ICustomOption>`
  color: ${({ fontColor }) => fontColor || '#161a30'};
  cursor: pointer;
  background-color: transparent;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

interface ICircle {
  category: EquipmentStatusCategoryOptions;
}

export const Circle = styled.div<ICircle>`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  border: 3px solid
    ${({ category }) => {
      if (category === 'Online') return '#dcf2ea';
      if (category === 'Offline') return '#ffefd2';
      return '#e6e8f0';
    }};
  background-color: ${({ category }) => {
    if (category === 'Online') return '#52bd94';
    if (category === 'Offline') return '#ff9900';
    return '#8f95b2';
  }};

  margin-right: 5px;
`;
